import { z } from 'zod';
import { SortOrderSchema } from './enums.schema';

/**
 * Pagination Schema
 * Common pagination and sorting functionality
 */

// Pagination Schema
export const PaginationSchema = z.object({
  limit: z
    .number()
    .int()
    .min(1, { message: "Limit must be at least 1" })
    .max(100, { message: "Limit cannot exceed 100" })
    .default(20),
  
  offset: z
    .number()
    .int()
    .min(0, { message: "Offset cannot be negative" })
    .default(0),
    
  sortOrder: SortOrderSchema.default('desc')
});

// Export TypeScript types
export type Pagination = z.infer<typeof PaginationSchema>;